<template>
    <section class="container relative">
        <div class="w-full max-lg:mt-5">
            <AtomTitle :class="titleClass">
                {{ title }}
            </AtomTitle>

            <FaqCategory
                :questions
                v-model="activeQuestionSlug" />
        </div>
    </section>
</template>

<script setup lang="ts">
import type {
    TCromiRentDirectionSlug,
    TDirectionSlug,
} from '~/types/global.types'

import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import type { IFAQItem } from '~/components/pages/directions/faq-section/faq-section.types'
import FaqCategory from '~/components/pages/faq/faq-category/FaqCategory.vue'

const route = useRoute()

const props = defineProps({
    title: {
        type: String,
        default: 'Часто задаваемые вопросы',
    },
    titleClass: {
        type: String,
        default: '',
    },
    questions: {
        type: Array as PropType<IFAQItem[]>,
        required: true,
    },
    directionSlug: {
        type: [String, null] as PropType<
            TDirectionSlug | TCromiRentDirectionSlug | null
        >,
        default: null,
    },
})

const activeQuestionSlug = ref<string | undefined>(props.questions[0]?.slug)

if (route.name !== 'catalog-product') {
    useSchemaOrg([
        defineWebPage({
            mainEntity: [
                ...props.questions.map((question: IFAQItem) =>
                    defineQuestion({
                        name: question.question,
                        acceptedAnswer: question.answer,
                    })
                ),
            ],
        }),
    ])
}
</script>
